@if (visible) {
  <ion-backdrop class="custom-loader-backdrop"></ion-backdrop>
}
@if (visible) {
  <div class="custom-loader-container">
    <ion-spinner name="crescent"></ion-spinner>
    <p>{{ message }}</p>
  </div>
}